/** Dev-only auth spinner / state diagnostics (set window.__ZCARS_AUTH_DIAG__ = true in prod). */

function authDiagEnabled() {
  if (process.env.NODE_ENV === "development") return true;
  return typeof window !== "undefined" && window.__ZCARS_AUTH_DIAG__ === true;
}

export function authDiagLog(event, payload = {}) {
  if (!authDiagEnabled()) return;
  // eslint-disable-next-line no-console
  console.log("[zcars-auth]", event, payload);
}
